<template>
	<div class="grouping-child">
		<div 
			v-for="(item,index) in list" :key="index" 
			@click="goFeatureUrl(item)"  class="moduleBtn"
		>	
			<!-- 功能的图标 -->
			<div class="moduleBtn-img" :style="{'background': item.color?item.color:''}">
				<i class="iconfont" :class="item.icon" v-if="item.icon" ></i>
				<image :src="item.fpicurl" v-if="item.fpicurl" style="width: 70%;height: 70%;"></image>
			</div>
			<!-- 功能名称 -->
			<span class="columnCenter">{{item.fname}}</span>
		</div>
		<!-- 用于排序不乱问题 -->
		<div class="mBtn"></div>
		<div class="mBtn"></div>
		<div class="mBtn"></div>
	</div>
</template>

<script>
	export default {
		props:{
			list:{
				type:Array,
				default:()=>[]
			},
			// 删除图标
			isShangchu:{
				type:Boolean,
				default:false
			},
			// 添加图标
			isTianjia:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
				
			};
        },
		methods:{
			goFeatureUrl(e){
				this.$emit('goFeatureUrl',e)
			},
			addFunctions(e){
				this.$emit('addEvent',e)
				
			},
			deleteFunctions(e,index){
				this.$emit('deleteEvent',e,index)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.grouping-child{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		flex-wrap: wrap;
		.moduleBtn{
            width:calc(100% / 4 - 0.5%);
			height: 130px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
            position: relative;
            margin-bottom:0.5%;
            border: 1px solid #eee;
			.moduleBtn-img{
				width: 40px;
				height: 40px;
				border-radius: 50%;
				background:linear-gradient(to bottom,  #90EBFC ,#7CD7FC); 
				display: flex;
				justify-content: center;
				align-items: center;
				.iconfont{
					font-size: 25px;
					color: #fff
				}
			}
			// 竖排居中
			.columnCenter{
				display: inline-block;
				font-size: 14px;
                margin-top: 10px;
                color: #333;
			}
		}
		.mBtn{
			height: 0px;
			width: 150px;
		}
	}
	.iconshanchu{
		position: absolute;
		right: 20px;
		top:0px
	}
	.icontianjia{
		position: absolute;
		right: 20px;
		top:0px
	}
</style>



// WEBPACK FOOTER //
// src/components/gongju/Nav-nca.vue